module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.integration && _vm.integration.id) ? _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.requests.forms.loading,
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.getForms
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v("\n      Jotform\n      "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    attrs: {
      "label": "",
      "dark": "",
      "color": "success"
    }
  }, [_vm._v("BETA")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-1"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "pr-0",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "",
      "two-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Jotforms")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.filteredForms), function(form) {
    return [_c('form-list-item', {
      key: form.id,
      attrs: {
        "item": form,
        "show-deleted": _vm.showDeleted
      },
      on: {
        "link": _vm.showLinkFormDialog,
        "selected": _vm.setSelectedForm
      }
    }), _vm._v(" "), (_vm.showDeleted || form.status !== "DELETED") ? _c('v-divider', {
      key: ("div-" + (form.id))
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "ml-3"
  }, [_c('v-checkbox', {
    staticClass: "ma-0 mt-2 pa-0",
    attrs: {
      "dense": "",
      "hide-messages": "",
      "small": "",
      "label": "Show deleted forms"
    },
    model: {
      value: (_vm.showDeleted),
      callback: function($$v) {
        _vm.showDeleted = $$v
      },
      expression: "showDeleted"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "dense": "",
      "hide-messages": "",
      "small": "",
      "label": "Show archived forms"
    },
    model: {
      value: (_vm.showArchived),
      callback: function($$v) {
        _vm.showArchived = $$v
      },
      expression: "showArchived"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "dense": "",
      "hide-messages": "",
      "small": "",
      "label": "Show unlinked forms"
    },
    model: {
      value: (_vm.showUnlinked),
      callback: function($$v) {
        _vm.showUnlinked = $$v
      },
      expression: "showUnlinked"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [(_vm.selectedForm && _vm.selectedForm.id) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "ma-0",
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_vm._v("\n              " + _vm._s(_vm.selectedForm.title) + "\n              "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "small": "",
      "disabled": !_vm.selectedForm.linked_form
    },
    on: {
      "click": function($event) {
        _vm.formSettingsDialog = true
      }
    }
  }, [_vm._v("\n                Settings\n                "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedForm.linked_form,
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.validatedialog = true
      }
    }
  }, [_vm._v("\n                Connect\n                "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("sync_alt")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedForm.linked_form,
      "target": "_blank",
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.sharedialog = true
      }
    }
  }, [_vm._v("\n                Share\n                "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("share")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": _vm.activeFormJotFormUrl,
      "target": "_blank",
      "flat": "",
      "small": ""
    }
  }, [_vm._v("\n                Open in JotForm\n                "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": !_vm.selectedForm.linked_form,
      "type": "warning"
    }
  }, [_vm._v("\n              Note: This form has not been linked to AppointmentGuru.\n              Would you like to link it now?\n              "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.linkdialog = true
      }
    }
  }, [_vm._v("Link form")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.selectedForm && _vm.selectedForm.linked_form) ? _c('v-card-title', {
    staticClass: "caption py-1 info--text",
    on: {
      "click": function($event) {
        _vm.formSettingsDialog = true
      }
    }
  }, [(_vm.selectedForm.linked_form.include_on_appointment_page) ? _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")]), _vm._v(" linked in notifications\n                "), _c('help-popover', {
    staticClass: "ml-4",
    attrs: {
      "small": ""
    }
  }, [_c('ul', [_c('li', [_vm._v("If you are using the default notifications, this will add a link to a page with all your forms linked.")]), _vm._v(" "), _c('li', [_vm._v("It will add the necessary information to link form submissions to your clients in AppointmentGuru.")]), _vm._v(" "), _c('li', [_vm._v("If you have customized your notifications, this link might not be added")]), _vm._v(" "), _c('li', [_vm._v("Links to your forms will show on the client's appointment detail page")]), _vm._v(" "), _c('li', [_vm._v("Links will not be included if the client has already completed the form")])])])], 1) : _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "warning"
    }
  }, [_vm._v("fiber_manual_record")]), _vm._v(" not linked in notifications\n                "), _c('help-popover', {
    staticClass: "ml-4",
    attrs: {
      "small": ""
    }
  }, [_c('ul', [_c('li', [_vm._v("If you are using the default notifications, this will add a link to a page with all your forms linked.")]), _vm._v(" "), _c('li', [_vm._v("It will add the necessary information to link form submissions to your clients in AppointmentGuru.")]), _vm._v(" "), _c('li', [_vm._v("If you have customized your notifications, this link might not be added")]), _vm._v(" "), _c('li', [_vm._v("Links to your forms will show on the client's appointment detail page")]), _vm._v(" "), _c('li', [_vm._v("Links will not be included if the client has already completed the form")])])])], 1), _vm._v(" "), _c('v-spacer'), _vm._v("\n\n              Available in these spaces:\n              "), _c('space-faces', {
    attrs: {
      "space-ids": _vm.selectedForm.linked_form.spaces
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-2 ml-4",
    attrs: {
      "small": "",
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n                Recent submissions\n                "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "loading": _vm.requests.submissions.loading
    },
    on: {
      "click": function($event) {
        return _vm.getSubmissions(_vm.selectedForm.id)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.requests.submissions.loading) ? _c('tombstone') : [(_vm.submissions && _vm.submissions.length === 0) ? _c('p', {
    staticClass: "caption pa-3"
  }, [_vm._v("No submissions found")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.submissions), function(submission) {
    return [_c('submission-list-item', {
      key: submission.id,
      attrs: {
        "item": submission
      },
      on: {
        "assign_client": function($event) {
          _vm.assigndialog = true;
          _vm.selectedSubmission = submission
        }
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (submission.id))
    })]
  })]], 2)], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.integrations && _vm.integrations.other_forms && _vm.integrations.other_forms.length > 0) ? _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-card-title', {
    staticClass: "overline py-1 grey lighten-4"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": "",
      "color": "info"
    }
  }, [_vm._v("info")]), _vm._v("\n      Some other forms have been linked by a colleague of yours\n    ")], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', [_vm._l((_vm.integrations.other_forms), function(form) {
    return [_c('form-list-item', {
      key: form.id,
      attrs: {
        "item": form,
        "readonly": ""
      }
    })]
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('install-jot-form', {
    attrs: {
      "integration": _vm.integration
    },
    on: {
      "ok": _vm.getConfig,
      "delete": _vm.getConfig
    }
  }), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.formSettingsDialog),
      callback: function($$v) {
        _vm.formSettingsDialog = $$v
      },
      expression: "formSettingsDialog"
    }
  }, [(_vm.selectedForm && _vm.selectedForm.linked_form) ? _c('form-settings', {
    attrs: {
      "form-id": _vm.selectedForm.linked_form.id
    },
    on: {
      "close": function($event) {
        _vm.formSettingsDialog = false
      },
      "success": _vm.getForms
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.assigndialog),
      callback: function($$v) {
        _vm.assigndialog = $$v
      },
      expression: "assigndialog"
    }
  }, [(_vm.selectedSubmission && _vm.selectedForm && _vm.selectedForm.linked_form) ? _c('assign-form', {
    attrs: {
      "form-id": _vm.selectedForm.linked_form.id
    },
    on: {
      "close": function($event) {
        _vm.assigndialog = false
      }
    },
    model: {
      value: (_vm.selectedSubmission),
      callback: function($$v) {
        _vm.selectedSubmission = $$v
      },
      expression: "selectedSubmission"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.linkdialog),
      callback: function($$v) {
        _vm.linkdialog = $$v
      },
      expression: "linkdialog"
    }
  }, [(_vm.selectedForm) ? _c('link-jot-form', {
    attrs: {
      "form": _vm.selectedForm
    },
    on: {
      "close": function($event) {
        _vm.linkdialog = false
      },
      "success": _vm.formLinked
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs,
      "fullscreen": ""
    },
    model: {
      value: (_vm.validatedialog),
      callback: function($$v) {
        _vm.validatedialog = $$v
      },
      expression: "validatedialog"
    }
  }, [(_vm.validatedialog && _vm.selectedForm && _vm.selectedForm.id) ? _c('validate-form', {
    attrs: {
      "form-id": _vm.selectedForm.id,
      "webhook-key": _vm.webhookKey
    },
    on: {
      "close": _vm.closeValidate
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "520"
    },
    model: {
      value: (_vm.sharedialog),
      callback: function($$v) {
        _vm.sharedialog = $$v
      },
      expression: "sharedialog"
    }
  }, [(_vm.sharedialog && _vm.selectedForm && _vm.selectedForm.id) ? _c('share-form', {
    attrs: {
      "form-id": _vm.selectedForm.id
    },
    on: {
      "close": function($event) {
        _vm.sharedialog = false
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48d4c760","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/JotForm/index.vue
// module id = 1658
// module chunks = 0